export const sendEmail = async (
  pdfContent: string,
  htmlContent: string,
  to: string | string[],
  subject: string,
  filename?: string,
  from?: string,
) => {
  try {
    // Replace 'YOUR_FIREBASE_FUNCTION_URL_HERE' with your actual deployed Firebase Cloud Function URL
    const firebaseFunctionUrl = "YOUR_FIREBASE_FUNCTION_URL_HERE"

    const response = await fetch(firebaseFunctionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pdfContent, htmlContent, to, from, subject, filename }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || "Failed to send email")
    }

    return await response.json()
  } catch (error) {
    console.error("Error in sendEmail service:", error)
    throw error
  }
}
